import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Spinner } from './UI';

export function PrivateRoute({ children }) {
  const { usuario, carregando } = useAuth();

  if (carregando) {
    return <Spinner />;
  }

  if (!usuario) {
    return <Navigate to="/login" replace />;
  }

  return children;
}
